<template>
    <div>
        <div>
            <div class="card-header pt-0">
                <div class="row justify-content-between align-items-center">
                    <div class="col-12 text-right">
                        <Button @click="openModal('descargar-resumen')" class="descargarResumen mr-2">Descargar Resumen</Button>
                        <Button @click="openModal('descargar-arqueo-caja')" class="descargarResumen">Descargar Arqueo Caja</Button>
                    </div>
                    <div class="col-12 mb-3 mb-lg-0">
                        <div class="row">
                            <div class="col-12 col-lg-4 mb-3 mb-lg-0">
                                <div class="form-group">
                                    <SearchComponent class="pt-3" big="true" v-model="filters.search"/>
                                </div>
                            </div>
                            <div class="col-12 col-lg-4 mb-3 mb-lg-0">
                                <div class="form-group">
                                    <label for="del">DEL</label>
                                    <input type="date" class="form-control" style="padding: 5.5px" id="del" placeholder="Del" v-model="filters.fecha_inicio"/>
                                </div>
                            </div>
                            <div class="col-12 col-lg-4">
                                <div class="form-group">
                                    <label for="al">AL</label>
                                    <input type="date" class="form-control" style="padding: 5.5px" id="al" placeholder="Al" v-model="filters.fecha_fin"/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-lg-4">
                                <div class="form-group">
                                    <select class="custom-select w-100" id="teatros" v-model="filters.search_teatro_id" v-if="teatros.length > 0">
                                        <option value="">Buscar por teatro</option>
                                        <option v-for="teatro in teatros" :value="teatro.id" :key="teatro.id">{{ teatro.nombre }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-12 col-lg-4">
                                <div class="form-group">
                                    <select class="custom-select w-100" id="taquilleros" v-model="filters.taquillero_id" v-if="taquilleros.length > 0">
                                        <option value="">Buscar por taquillero</option>
                                        <option v-for="taquillero in taquilleros" :value="taquillero.id" :key="taquillero.id">{{ taquillero.nombre }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-12 col-lg-4">
                                <div class="form-group">
                                    <multiselect
                                        v-if="companias.length > 0"
                                        style="max-height: 50px !important;"
                                        v-model="selectedCompania"
                                        placeholder="Buscar por compañia"
                                        label="nombre"
                                        track-by="id"
                                        :options="companias"
                                        :multiple="false"
                                        @input="onCompaniaSelected"
                                    >
                                        <template #noResult>
                                            <span>No se encontraron compañias con ese nombre.</span>
                                        </template>
                                    </multiselect>
                                </div>
                            </div>
                            <div class="col-12 col-lg-2">
                                <div class="form-group">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input" type="checkbox" id="pasados" v-model="filters.pasados" @change="handleCheckboxChange('pasados')"/>
                                        <label class="custom-control-label text-uppercase h7" style="font-size: 15px;" for="pasados">Eventos pasados</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-2">
                                <div class="form-group">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input" type="checkbox" id="actuales" v-model="filters.actuales" @change="handleCheckboxChange('actuales')"/>
                                        <label class="custom-control-label text-uppercase h7 btn-actuales" style="font-size: 15px;" for="actuales">Eventos actuales</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 text-right">
                                <Button @click.prevent="getEventos()">Buscar</Button>
                                <Button @click.prevent="clearFilters" class="pr-3 pl-3 ml-2" icon="fa fa-trash" name="tooltip" v-b-tooltip.hover.bottom title="Limpiar filtros"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ContentOrLoading>
            <div class="card-body" v-if="!loading">
                <div class="table-responsive has-options">
                    <table v-if="eventos" class="table table-hover text-nowrap">
                        <thead>
                            <tr>
                                <th class="text-center">CÓDIGO</th>
                                <th>NOMBRE</th>
                                <th class="text-center">FECHA</th>
                                <th class="text-center">NOMBRE TEATRO</th>
                                <th class="text-center">VENTAS TAQUILLA</th>
                                <th class="text-center">VENTAS ONLINE</th>
                                <th class="text-center">INVITACIONES</th>
                                <th class="text-center">TOTAL</th>
                                <th class="text-center">RECAUDACIÓN</th>
                                <th class="text-center">SESIONES</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(evento, index) in eventos.data">
                                <tr :key="index">
                                    <td class="text-center">{{ evento.codigo }}</td>
                                    <td>{{ evento.nombre_completo }}</td>
                                    <td class="text-center">{{ evento.fecha_inicio }}</td>
                                    <td class="text-center">{{ evento.teatro }}</td>
                                    <td class="text-center">{{ evento.taquilla.entradas_vendidas }}</td>
                                    <td class="text-center">{{ evento.online.entradas_vendidas }}</td>
                                    <td class="text-center">{{ evento.invitaciones.entradas_vendidas }}</td>
                                    <td class="text-center">{{ evento.taquilla.entradas_vendidas + evento.online.entradas_vendidas + evento.invitaciones.entradas_vendidas }}</td>
                                    <td class="text-center">{{ evento.online.singastos + evento.taquilla.singastos | formatear_precio }}</td>
                                    <td class="text-center">
                                        <button @click="toggleSesiones(evento)" class="btn btn-primary btn-sm">
                                            {{ evento.mostrarSesiones ? 'Ocultar Sesiones' : 'Ver Sesiones' }}
                                        </button>
                                    </td>
                                </tr>
                                <template v-if="evento.mostrarSesiones">
                                    <template v-if="!evento.sesiones">
                                        <tr :key="`evento-${index}`">
                                            <td colspan="10" class="text-center">
                                                <div class="spinner-border text-primary" role="status"></div>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-else v-for="(sesion, sIndex) in evento.sesiones">
                                        <tr :key="`evento-${index}-sesion-${sIndex}`">
                                            <td></td>
                                            <td><strong>{{ sesion.nombre_completo }}</strong></td>
                                            <td class="text-center"><strong>{{ sesion.fecha_inicio }}</strong></td>
                                            <td class="text-center"><strong>{{ evento.teatro }}</strong></td>
                                            <td class="text-center"><strong>{{ sesion.taquilla.entradas_vendidas }}</strong></td>
                                            <td class="text-center"><strong>{{ sesion.online.entradas_vendidas }}</strong></td>
                                            <td class="text-center"><strong>{{ sesion.invitaciones.entradas_vendidas }}</strong></td>
                                            <td class="text-center">
                                                <strong>{{ sesion.taquilla.entradas_vendidas + sesion.online.entradas_vendidas + sesion.invitaciones.entradas_vendidas }}</strong>
                                            </td>
                                            <td class="text-center">
                                                <strong>{{ sesion.online.singastos + sesion.taquilla.singastos | formatear_precio }}</strong>
                                            </td>
                                            <td class="text-center">
                                                <button @click="toggleResumenVentas(evento.id, sesion)" class="btn btn-primary btn-sm">
                                                    {{ sesion.mostrarDesgloseVentas ? 'Ocultar Ventas' : 'Ventas' }}
                                                </button>
                                            </td>
                                        </tr>

                                        <template v-if="sesion.mostrarDesgloseVentas">
                                            <tr v-if="!sesion.desglose_ventas" :key="`evento-${index}-sesion-${sIndex}-loading`">
                                                <td colspan="10" class="text-center" v-if="loading">
                                                    <div class="spinner-border text-primary" role="status"></div>
                                                </td>
                                                <td colspan="10" class="text-center" v-else-if="sesionError">
                                                    <span class="text-danger">{{ sesionError }}</span>
                                                </td>
                                            </tr>
                                            <template v-else>
                                                <template v-if="sesion.desglose_ventas.length">
                                                    <tr v-for="(desglose, dIndex) in sesion.desglose_ventas" :key="`evento-${index}-sesion-${sIndex}-desglose-${dIndex}`">
                                                        <td colspan="3"></td>
                                                        <td class="text-center"><strong>{{ desglose.nombre_zona }}</strong></td>
                                                        <td class="text-center"><strong>{{ desglose.venta_taquilla }}</strong></td>
                                                        <td class="text-center"><strong>{{ desglose.venta_online }}</strong></td>
                                                        <td class="text-center"><strong>{{ desglose.venta_invitaciones }}</strong></td>
                                                        <td class="text-center"><strong>{{ desglose.total_entradas }}</strong></td>
                                                        <td class="text-center"><strong>{{ desglose.total_precio | formatear_precio }}</strong></td>
                                                        <td colspan="1"></td>
                                                    </tr>
                                                </template>
                                                <template v-else>
                                                    <tr :key="`no-desglose-evento-${index}-sesion-${sIndex}`">
                                                        <td colspan="3"></td>
                                                        <td class="text-center"><strong>No hay ventas en esta sesión.</strong></td>
                                                        <td colspan="6"></td>
                                                    </tr>
                                                </template>
                                            </template>
                                        </template>
                                    </template>
                                </template>
                            </template>
                        </tbody>
                    </table>
                </div>
                <div class="row justify-content-between">
                    <div class="col-12 col-lg-3">
                        <ElementosPorPaginaComponent v-model="filters.per_page" @change="debouncedGetEventos"/>
                    </div>
                    <div class="col-12 col-lg-4" v-if="eventos">
                        <PaginateComponent
                            :current_page="eventos.meta.current_page"
                            :last_page="eventos.meta.last_page"
                            v-on:change_page="setPage"
                        />
                    </div>
                </div>
                <DescargarResumenVentas
                    :del="filters.fecha_inicio"
                    :al="filters.fecha_fin"
                    :teatro_id="filters.search_teatro_id" 
                    :taquillero_id="filters.taquillero_id"
                    :teatro_company_id="filters.teatro_company_id"
                    :pasado="filters.pasados"
                    :actual="filters.actuales"
                    :teatros="teatros"
                    :taquilleros="taquilleros"
                    :companias="companias"
                    name="descargar-resumen"
                    @close="closeModal" 
                />
                <DescargarArqueoCaja
                    :del="filters.fecha_inicio"
                    :al="filters.fecha_fin"
                    :teatro_id="filters.search_teatro_id" 
                    :taquillero_id="filters.taquillero_id"
                    :teatro_company_id="filters.teatro_company_id"
                    :pasado="filters.pasados"
                    :actual="filters.actuales"
                    :teatros="teatros"
                    :taquilleros="taquilleros"
                    :companias="companias"
                    name="descargar-arqueo-caja"
                    @close="closeModal" 
                />
            </div>
        </ContentOrLoading>
    </div>
</template>

<script>
    import SearchComponent from "@/components/backend/components/SearchComponent";
    import PaginateComponent from "@/components/table/pagination/BackPaginateComponent";
    import ElementosPorPaginaComponent from "@/components/backend/components/ElementosPorPaginaComponent";
    import DescargarResumenVentas from "@/components/backend/eventos/Modal/DescargarResumenVentas";
    import DescargarArqueoCaja from "@/components/backend/eventos/Modal/DescargarArqueoCaja";

    export default {
        data() {
            return {
                eventos: null,
                loading: true,
                teatros: [],
                taquilleros: [],
                companias: [],
                sesionError: null,
                selectedCompania: null,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: "",
                    search_teatro_id: "",
                    taquillero_id: "",
                    teatro_company_id: "",
                    fecha_inicio: null,
                    fecha_fin: null,
                    pasados: false,
                    actuales: true
                }
            }
        },
        created() {
            this.debouncedGetEventos = _.debounce(this.getEventos, 500);
            this.getEventos();
            this.getTeatros();
            this.getTaquilleros();
            this.getCompanias();

            if (this.eventos) {
                this.eventos.data.forEach(evento => {
                    this.$set(evento, 'mostrarSesiones', false);

                    evento.sesiones.forEach(sesion => {
                        this.$set(sesion, 'mostrarDesgloseVentas', false);
                    })
                });
            }
        },
        watch: {
            "filters.search"() {
                this.debouncedGetEventos();
            },
        },
        methods: {
            getEventos() {
                this.loading = true;

                const data = {
                    filters: this.filters,
                };

                this.$store.dispatch(this.config.getVuexAlias("back.events.resumen-ventas"), data).then(res => {
                    this.eventos = res.data;
                }).finally(() => {
                    this.loading = false;
                });
            },
            getInfoSesiones(evento) {
                this.loading = true;
                const data = {
                    filters: {
                        fecha_desde: this.filters.fecha_inicio,
                        fecha_hasta: this.filters.fecha_fin
                    },
                    event_id: evento.id
                }
                this.$store.dispatch(this.config.getVuexAlias("back.events.resumen-ventas.sesiones"), data).then(res => {
                    this.$set(evento, 'sesiones', res.data.data);
                }).catch(error => {
                    console.error(error);
                    this.sesionError = error.response?.data?.message || 'Error al obtener las sesiones del evento.';
                    this.$toast.error('Error al obtener las sesiones del evento.');
                });
                this.loading = false;
            },
            getInfoDesgloseVentasSesion(evento_id, sesion) {
                this.loading = true;
                const data = {
                    filters: {
                        taquillero_id: this.filters.taquillero_id,
                        fecha_inicio: this.filters.fecha_inicio,
                        fecha_fin: this.filters.fecha_fin
                    },
                    event_id: evento_id,
                    sesion_id: sesion.id
                }
                this.$store.dispatch(this.config.getVuexAlias("back.events.resumen-ventas.sesion.desglose"), data).then(res => {
                    this.$set(sesion, 'desglose_ventas', res.data.data);
                }).catch(error => {
                    console.error(error);
                    this.sesionError = error.response?.data?.message || 'Error al obtener el desglose de ventas.';
                    this.$toast.error('Error al obtener el desglose de ventas de la sesión.');
                });
                this.loading = false;
            },
            getTeatros() {
                let params = {filters: {}};

                this.$store.dispatch(this.config.getVuexAlias('back.usuarios.teatros'), params).then(res => {
                    this.teatros = res.data.data;
                })
            },
            getTaquilleros() {
                let params = {filters: {}};

                this.$store.dispatch(this.config.getVuexAlias('back.taquilleros.index'), params).then(res => {
                    this.taquilleros = res.data.data;
                })
            },
            getCompanias() {
                const params = {
                    filters : this.filters,
                    teatro_id: this.teatro.id,
                    to_select: true
                };

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.compania-eventos.index'), params).then(res => {
                    this.companias = res.data.data;
                })
            },
            handleCheckboxChange(type) {
                if (type === 'pasados' && this.filters.pasados) {
                    this.filters.actuales = false;
                } else if (type === 'actuales' && this.filters.actuales) {
                    this.filters.pasados = false;
                }
            },
            setPage(page) {
                this.filters.page = page;
                this.getEventos();
            },
            openModal(name) {
                this.$modal.show(name);
            },
            closeModal(name) {
                this.$modal.hide(name);
            },
            toggleSesiones(evento) {
                this.$set(evento, 'mostrarSesiones', !evento.mostrarSesiones);

                if (!evento.mostrarSesiones && evento.sesiones) {
                    evento.sesiones.forEach(sesion => {
                        this.$set(sesion, 'mostrarDesgloseVentas', false);
                    });
                }

                if (evento.mostrarSesiones && !evento.sesiones) {
                    this.getInfoSesiones(evento);
                }
            },
            toggleResumenVentas(evento_id, sesion) {
                this.$set(sesion, 'mostrarDesgloseVentas', !sesion.mostrarDesgloseVentas);

                if (sesion.mostrarDesgloseVentas && !sesion.desglose_ventas) {
                    this.getInfoDesgloseVentasSesion(evento_id, sesion);
                }
            },
            onCompaniaSelected(selectedCompania) {
                this.selectedCompania = selectedCompania;
                
                if (selectedCompania && selectedCompania.id) {
                    this.filters.teatro_company_id = selectedCompania.id;
                } else {
                    this.filters.teatro_company_id = "";
                }
            },
            clearFilters() {
                this.filters.per_page = 10;
                this.filters.page = 1;
                this.filters.search = "";
                this.filters.search_teatro_id = "";
                this.filters.taquillero_id = "";
                this.filters.teatro_company_id = "";
                this.filters.fecha_inicio = null;
                this.filters.fecha_fin = null;
                this.filters.pasados = false;
                this.filters.actuales = false;
                this.selectedCompania = null; 

                this.getEventos();
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        components: {
            SearchComponent,
            PaginateComponent,
            ElementosPorPaginaComponent,
            DescargarResumenVentas,
            DescargarArqueoCaja
        }
    }
</script>

<style scoped>
    .multiselect {
        border: 1px solid #ced4da;
        border-radius: .25rem;
    }

    @media (max-width: 768px) {
        .descargarResumen {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        };
     }
</style>